package top.wcpe.allincore.ui.runtime.reactive

import kotlin.jvm.JvmStatic

/**
 * 反应式集合包装门面（路线 B）。
 *
 * 把普通 List / Map 递归包装成 [ReactiveList] / [ReactiveMap]，使 state / session / persist 字段在
 * mutate 时自动触发 UI 重组。
 *
 * 包装时机（仅以下三处）：state 默认值初始化、`state.x/session.x/persist.x = rhs` 赋值、session /
 * persist Signal 首次创建时的默认值。不包装 DSL 字面量、`map.list/map.map` 拷贝出的中间结果、
 * net.request 响应 payload（这些需赋回 state 才由赋值钩子重新 wrap）。
 *
 * 已是 [ReactiveList] / [ReactiveMap] 的对象直接返回，避免重复包装。
 */
object ReactiveWrapper {

    /**
     * 递归把 List/Map 包装成反应式集合。
     *
     * 对 List：每个元素都递归 wrap，产物是 [ReactiveList]；对 Map：每个 value 都递归 wrap，产物是
     * [ReactiveMap]；非 List/Map 标量原样返回。
     */
    @JvmStatic
    fun wrap(value: Any?): Any? = when (value) {
        null -> null
        is ReactiveList, is ReactiveMap -> value
        is Map<*, *> -> {
            val reactiveMap = ReactiveMap()
            for ((key, entryValue) in value) {
                val wrapped = wrap(entryValue)
                if (wrapped != null) {
                    reactiveMap.put(key.toString(), wrapped)
                }
            }
            reactiveMap
        }

        is List<*> -> {
            val reactiveList = ReactiveList()
            for (item in value) {
                val wrapped = wrap(item)
                if (wrapped != null) reactiveList.add(wrapped)
            }
            reactiveList
        }

        else -> value
    }
}
